import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box, Button, Dialog, Typography } from '@mui/material';
import { TravelerTruss, getTrussDescription } from '../types';

interface CompletionModalProps {
  open: boolean;
  truss: TravelerTruss | null;
  onClose: () => void;
}

const CompletionModal = ({ open, truss, onClose }: CompletionModalProps) => {
  if (!truss) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: '12px',
          p: 4,
          textAlign: 'center',
          maxWidth: 400,
        },
      }}
    >
      <Box
        sx={{
          width: 80,
          height: 80,
          bgcolor: '#27ae60',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mx: 'auto',
          mb: 2.5,
        }}
      >
        <CheckCircleIcon sx={{ fontSize: 40, color: '#fff' }} />
      </Box>
      <Typography variant="h5" sx={{ fontWeight: 600, color: '#333', mb: 1.5 }}>
        Job Complete!
      </Typography>
      <Typography sx={{ fontSize: '14px', color: '#666', mb: 3 }}>
        <strong>
          {getTrussDescription(truss)} (QTY: {truss.quantity})
        </strong>
        <br />
        <br />
        All production stages have been completed and verified.
        <br />
        This truss is now locked and ready for delivery.
      </Typography>
      <Button
        variant="contained"
        onClick={onClose}
        sx={{
          bgcolor: '#27ae60',
          '&:hover': { bgcolor: '#219a52' },
          fontWeight: 600,
          px: 4,
          py: 1.5,
        }}
      >
        Continue
      </Button>
    </Dialog>
  );
};

export default CompletionModal;
